import { css } from 'styled-components';
/**
 * Generates a media query containing the provided CSS. Requires passing in
 * either a minimum width, maximum width or both.
 * @param options.min The minimum width to use for the media query.
 * @param options.max The maximum width to use for the media query.
 * @param styles The css to insert into the media query. This should be
 * created using the `css` helper from styled-components.
 */
export var mediaQuery = function mediaQuery(_ref, styles) {
  var max = _ref.max,
    min = _ref.min;
  var fromQuery = function fromQuery(size) {
    return size ? "and (min-width: ".concat(size, "px)") : '';
  };
  var toQuery = function toQuery(size) {
    return size ? "and (max-width: ".concat(size, "px)") : '';
  };
  return css(["@media only screen ", " ", "{", "}"], fromQuery(min), toQuery(max), styles);
};